<template>
  <v-container>
    <v-layout v-if="data && Object.keys(data).length !== 0" row wrap class="pa-5">
      <v-layout id="printLayout" justify-center row wrap>

        <v-row style="text-align: center; margin-top: 3em;" class="printShow">
          <v-col cols="12">
            <span style="top: -35px; left: 30px; position: absolute;">
              <img src="img/mdkgu.png" alt="MDKGU Logo" height="90" width="90">
            </span>
            <span>MAJLIS DAERAH KENINGAU</span><br />
            <span>PETI SURAT 181, 89008 KENINGAU, Sabah, Malaysia</span><br />
            <span>TEL: 087-341152 FAX: 087-339986</span>
          </v-col>
          <qrcode-vue :value="url" level="H" style="margin-left: 85%; margin-top: -6em;"></qrcode-vue>
        </v-row>

        <v-flex xs12 :sm6="!isPrintModeActive" class="property_info">
          <h3 class="printShow" style="padding: 10px;">{{ $t('page_assessment.property_account_info') }}</h3>
          <hr class="printShow" />
          <v-list two-line class="display-flex" dense>
            <v-subheader class="printNone"><h3>{{ $t('page_assessment.property_account_info') }}</h3></v-subheader>
            <v-divider class="printNone"/>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.assessment_no }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.account_no') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-braille fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.property_id }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.property_id') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-file-text fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.current_title }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.title_no') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-home fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ annualRate(data) | currency('RM ') }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.rate', { type: data.landcess_effect === "N" ? "Assessment" : "Landcess" }) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <br class="printNone">
          <v-list two-line dense>
            <h3 class="printShow" style="padding: 10px;">{{ $t('page_assessment.owner_info') }}</h3>
            <hr class="printShow">
            <v-subheader class="printNone"><h3>{{ $t('page_assessment.owner_info') }}</h3></v-subheader>
            <v-divider class="printNone"/>
          </v-list>
          <v-list two-line class="display-flex" dense>
             <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-user-circle fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ hideText(data.name) }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.owner') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-home fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.house_no }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.house_no') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-list fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.floor }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.floor') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-th fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.lot }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.lot') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-building fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.block }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.block') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list two-line dense>
            <v-list-item>
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-map-marker fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-card class="body-2 elevation-0">{{ data.locality }}</v-card>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.locality') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <h3 class="printShow" style="padding: 10px;">{{ $t('page_assessment.previous_payment_info') }}</h3>
            <hr class="printShow">
          </v-list>
          <br class="printNone">
          <v-list two-line class="display-flex" dense>
            <v-subheader class="printNone"><h3>{{ $t('page_assessment.previous_payment_info') }}</h3></v-subheader>
            <v-divider class="printNone"/>
            <v-list-item :class="isPrintModeActive ? '' : 'width25'">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-calendar fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.last_pay_date | dateTime }}</v-list-item-title>
                <v-list-item-subtitle :class="!isPrintModeActive ? 'body-2': ''">{{ $t('page_assessment.last_payment_date') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-calendar fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.paid_until }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.paid_until') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-card class="body-2 elevation-0">{{ data.receipt_no }}</v-card>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.receipt_no_last_received') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-card class="body-2 elevation-0">{{ Number(data.last_paid_amount / 100) | currency('RM ') }}</v-card>
                <v-list-item-subtitle :class="!isPrintModeActive ? 'body-2': ''">{{ $t('page_assessment.total_last_payment') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-flex>
        <v-flex xs12 :sm6="!isPrintModeActive" :pt-3="$vuetify.breakpoint.xsOnly">
          <v-layout column>
            <h3 class="printShow" style="padding: 10px;">{{ $t('page_assessment.payment_info') }}</h3>
            <hr class="printShow">
            <v-list three-line class="display-flex" dense>
              <v-subheader class="printNone"><h3>{{ $t('page_assessment.payment_info') }}</h3></v-subheader>
              <v-divider class="printNone"/>
              <v-list-item class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{ (arrears(data)) | currency('RM ') }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('page_assessment.arrears') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{ (current_value(data)) | currency('RM ') }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('page_assessment.current') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-card class="body-2 elevation-0">{{ (interest(data)) | currency('RM ') }}</v-card>
                  <v-list-item-subtitle class="body-2">{{ $t('page_assessment.interest') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-card class="body-2 elevation-0">{{ (notice(data)) / 100 | currency('RM ') }}</v-card>
                  <v-list-item-subtitle class="body-2">{{ $t('page_assessment.notice') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list three-line class="display-flex" dense>
              <v-list-item class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-card class="body-2 elevation-0">{{ Number(data.assessment_miscellaneous / 100) | currency('RM ') }}</v-card>
                  <v-list-item-subtitle class="body-2">{{ $t('page_assessment.miscellaneous') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-card class="body-2 elevation-0">{{ data.full_payment > 0 ? (Number(data.full_payment + data.discount) / 100) : 0 | currency('RM ') }}</v-card>
                  <v-list-item-subtitle class="body-2">{{ $t('page_assessment.total_outstanding') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-card class="body-2 elevation-0">{{ Number(data.advance / 100) | currency('RM ') }}</v-card>
                  <v-list-item-subtitle class="body-2">{{ $t('page_assessment.advance_payment') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-card class="body-2 elevation-0">{{ (data.full_payment > 0 ? Number(data.discount / 100) : 0) | currency('RM ') }}</v-card>
                  <v-list-item-subtitle class="body-2">{{ $t('page_assessment.discount') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list three-line class="display-flex marginBottom40" dense>
              <v-list-item class="width">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-card class="title elevation-0"><strong>{{ Number(data.full_payment) / 100 | currency('RM ') }}</strong></v-card>
                  <v-list-item-subtitle class="body-2"><strong>{{ $t('page_assessment.total_payable') }}</strong></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <span class="text-center caption printShow pt-12">*Slip ini merupakan salinan tidak rasmi untuk rujukan peribadi sahaja.*</span>
            <span class="text-center caption printShow">Tarikh: {{ new Date().toLocaleString('en-GB') }}, Dicetak oleh: {{ username + ' @ App e-Services MDKGU' }} </span>
            <v-layout mt-2 class="printNone">
              <div class="row justify-end text-center">
                <v-col cols="12" xl="4" lg="4" md="4" sm="4">
                  <v-btn :block="$vuetify.breakpoint.xsOnly" color="teal" class="white--text" large rounded @click="payOnline(data)">{{ $t('page_assessment.pay_online') }}</v-btn>
                </v-col>
                <v-col cols="12" xl="4" lg="4" md="4" sm="4">
                  <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" large rounded @click="print(data)">{{ $t('page_assessment.print') }}</v-btn>
                </v-col>
              </div>
            </v-layout>
            <div class="row justify-end text-center mt-3 printNone" v-if="Number(data.full_payment) === 0" >
              <v-col cols="12" xl="8" lg="8" md="8" sm="8">
                <v-btn :block="$vuetify.breakpoint.xsOnly"  color="primary" class="white--text no-text-transform py-7" large rounded  style="white-space: pre-line;" @click="$router.push({ name: 'ticket-form', query:{ ass_acc_no: data.assessment_no, ticket: 'UDCT' }})">{{ $t('page_assessment.noc') }}</v-btn>
              </v-col>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import vuex from 'vuex'
import QrcodeVue from 'qrcode.vue'
import configurations from '../../configurations'

export default {
  beforeDestroy () {
    window.removeEventListener('afterprint', this.handleAfterPrint)
  },
  beforeMount () {
    this.fetchData({ id: atob(this.$route.params.id), type: 'assessment' })
  },
  components: {
    QrcodeVue
  },
  computed: {
    ...vuex.mapState({
      data: state => state.search.data,
      username: state => state.auth.username
    })
  },
  data () {
    return {
      url: configurations.host.eservices + '/' + window.location.hash,
      isPrintModeActive: false
    }
  },
  mounted () {
    window.addEventListener('afterprint', this.handleAfterPrint)
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'search/fetchData'
    }),
    handleAfterPrint () {
      this.isPrintModeActive = false
    },
    annualRate (data) {
      const result =
        Number(data.annual_general) +
        Number(data.annual_sewerage) +
        Number(data.annual_refuse_chute) +
        Number(data.annual_staircase) +
        Number(data.annual_other)
      return result / 100
    },
    arrears (data) {
      const result =
        Number(data.brought_forward_general) +
        Number(data.brought_forward_refuse_chute) +
        Number(data.brought_forward_other) +
        Number(data.brought_forward_sewerage) +
        Number(data.brought_forward_staircase)
      return result / 100
    },
    current_value (data) {
      if (data.full_payment === 0) return 0
      const result =
        Number(data.current_general) +
        Number(data.current_sewerage) +
        Number(data.current_other) +
        Number(data.current_staircase) +
        Number(data.current_refuse_chute)
      return result / 100
    },
    hideText (text) {
      var t = text
      var hiddenText = ''
      for (var i = 0; i < t.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += t[i]
        }
      }
      return hiddenText
    },
    interest (data) {
      const result =
        Number(data.brought_forward_interest) + Number(data.current_interest)
      return result / 100
    },
    notice (data) {
      const result =
        Number(data.brought_forward_notice) + Number(data.current_notice)
      return result / 100
    },
    payOnline (data) {
      if (!window.hasOwnProperty('cordova')) {
        window.location.href = `${configurations.host.epayment}/#/confirmation?_id=${
          btoa(data._id)
        }&council=${configurations.council}&payment_type=${data.type}`
        return
      }

      // mobile code start
      let ref = cordova.InAppBrowser.open(`${configurations.host.epayment}/#/confirmation?_id=${
        btoa(data._id)
      }&council=${configurations.council}&payment_type=${data.type}`, '_self', 'location=no,enableViewportScale=yes,zoom=no')
      let params = ''
      ref.addEventListener('loadstop', function (event) {
        if (event.url.substring(0, 31) === `${configurations.host.epayment}/#/receipt?`) {
          params = event.url.substring(31, event.url.length)
          ref.close()
          this.$router.push('/receipt?' + params)
        }
        if (event.url === `${configurations.host.epayment}/index.html#/` || event.url === `${configurations.host.epayment}/#/`) {
          ref.close()
          this.$router.push('/')
        }
      }.bind(this))

      // mobile code end
    },
    print (data) {
      this.isPrintModeActive = true
      this.$nextTick(() => {
        if (!window.hasOwnProperty('cordova')) {
          window.print()
          return
        }

        // mobile code start
        document.getElementsByTagName('noscript')[0].parentNode.removeChild(document.getElementsByTagName('noscript')[0])
        var page = document.documentElement
        cordova.plugins.printer.print(page, `${data.assessment_no}.html`)
        // mobile code end
      })
    }
  }
}
</script>

<style>
.br-10 {
  border-radius: 10px;
}

#councilInfo,
.printShow {
  display: none;
}

@media print {
  .v-app-bar {
    display: none;
  }
  #councilInfo,
  #councilInfo span {
    display: block;
    text-align: center;
  }
  #printLayout {
    margin-top: -110px;
  }
  .property_info {
    max-width: 400px;
  }
  .display-flex {
    display: flex;
  }
  .printShow {
    display: block;
  }
  .printNone {
    display: none;
  }
  .pageBreak {
    page-break-after: always;
  }
  .width25 {
    width: 25%;
  }
  .width33 {
    width: 33.33%;
  }
  .width50 {
    width: 50%;
  }
  .marginBottom40 {
    margin-bottom: -40px;
  }
}
</style>
